export class SizedMap<T, U> {
  constructor(public size: number) {}

  public map = new Map<T, U>();

  public set(key: T, value: U) {
    this.map.set(key, value);
    if (this.map.size > this.size) {
      this.map.delete(this.map.keys().next().value);
    }
  }

  public get(key: T): U | null {
    return this.map.get(key) ?? null;
  }

  public clear() {
    this.map = new Map<T, U>();
  }
}
